import * as React from "react";
import type { SVGProps } from "react";
const SvgAnalyticsChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 2.334h2a1 1 0 0 1 1 1v9.333a1 1 0 0 1-1 1h-3V3.334a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 13.667H6V7a1 1 0 0 1 1-1h3"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 10h3v3.667H3a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAnalyticsChart;
